import { render, staticRenderFns } from "./CatalogPageElementCategory.vue?vue&type=template&id=1665e110&scoped=true"
import script from "./CatalogPageElementCategory.vue?vue&type=script&lang=js"
export * from "./CatalogPageElementCategory.vue?vue&type=script&lang=js"
import style0 from "./CatalogPageElementCategory.vue?vue&type=style&index=0&id=1665e110&prod&lang=scss&scoped=true"
import style1 from "./CatalogPageElementCategory.vue?vue&type=style&index=1&id=1665e110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1665e110",
  null
  
)

export default component.exports